var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"upload-container"},[_c('Upload',{attrs:{"multiple":"multiple","type":"drag","accept":".jpg, .jpeg, .png, .gif, .svg","headers":{
      authorization: 'authorization-text',
    },"before-upload":_vm.beforeUpload,"default-file-list":_vm.fileList,"on-remove":_vm.handleRemove,"on-success":_vm.handleSuccess,"action":`${_vm.GLOBAL.UPLOAD_URL}/oss/upload`}},[_c('Button',{attrs:{"icon":"el-icon-upload","type":"primary"}},[_vm._v("上传图片")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }